const firebaseConfig = {
    apiKey: "AIzaSyAEfjmnMewrC1_ukTSvmXvsDTJDFlkDMOg",
    authDomain: "forms-e81aa.firebaseapp.com",
    projectId: "forms-e81aa",
    storageBucket: "forms-e81aa.appspot.com",
    messagingSenderId: "249201892476",
    appId: "1:249201892476:web:b1f1b4e7d9acdcd5383df9"
};


export default firebaseConfig;